import { type VFC } from 'react'

const ProgressSpinner: VFC = () => (
  <span className="u-display--inline-block">
    <span
      className="a-LoadingIndicator e-LoadingIndicatorSpinner u-color--white u-padding-x-small"
      role="progressbar"
    >
      <svg viewBox="22 22 44 44">
        <circle
          cx="44"
          cy="44"
          r="20.2"
          fill="none"
          strokeWidth="3.6"
          aria-label="Loading..."
        ></circle>
      </svg>
    </span>
  </span>
)

export default ProgressSpinner
